import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import '../styles/globals.css';

const Container = styled.div`
  max-width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--bg-page);
`;

const PageWrapper = styled.div`
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  padding: 0 24px 4rem 24px;

  @media (max-width: 768px) {
    padding: 0 16px 3rem 16px;
  }
`;

const TitleSection = styled.div`
  width: 100%;
  padding: 3rem 0 1.5rem 0;

  @media (max-width: 768px) {
    padding: 2rem 0 1rem 0;
  }
`;

const Title = styled.h1`
  font-family: var(--font-lora);
  font-weight: 600;
  color: var(--color-text);
  font-size: 2.5rem;
  line-height: 1.15;
  letter-spacing: -0.01em;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 1.75rem;
  }
`;

const Content = styled.div`
  color: var(--color-text);
  font-size: 1.0625rem;
  line-height: 1.7;

  p {
    margin-bottom: 1rem;
  }

  ul {
    margin: 0 0 1rem 1.5rem;

    li {
      margin-bottom: 0.5rem;
    }
  }

  a {
    color: var(--color-accent);
    text-decoration: underline;
    text-underline-offset: 2px;

    &:hover {
      color: var(--color-accent-hover);
    }
  }

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

// Pre-fills the email so people know what to include.
const MAILTO =
  'mailto:violet@ifp.org' +
  '?subject=' +
  encodeURIComponent('Correction to the prevailing-wage comments database') +
  '&body=' +
  encodeURIComponent(
    [
      'Comment ID (e.g. ETA-2026-0001-0014):',
      '',
      'What is wrong:',
      '',
      'Suggested correction (replacement summary text and/or changes to the tags):',
      '',
    ].join('\n')
  );

function Correction() {
  return (
    <Container>
      <PageWrapper>
        <TitleSection>
          <Title>Suggest a correction</Title>
        </TitleSection>

        <Content>
          <p>
            Spotted a mistake in how we summarized or tagged a comment? Email{' '}
            <a href={MAILTO}>violet@ifp.org</a> and let us know. Please include:
          </p>
          <ul>
            <li>
              <strong>Which comment</strong> — the comment ID (e.g.
              ETA-2026-0001-0014) or the organization/commenter name.
            </li>
            <li>
              <strong>What's wrong</strong> — a short explanation of the error.
            </li>
            <li>
              <strong>Your suggested correction</strong> — the replacement summary
              text, and/or which topic tags should be added or removed.
            </li>
          </ul>
          <p>
            We read every message and will update the record if the correction
            checks out.
          </p>
          <p>
            <Link to="/">Back to the database</Link> ·{' '}
            <Link to="/methodology">Methodology</Link>
          </p>
        </Content>
      </PageWrapper>
    </Container>
  );
}

export default Correction;
